import { useContext } from "react";
import { DeliveryFoodContext } from "../../../../DeliveryFoodContext";
import { DeliveryFoodItemRestaurantCell } from "../../../../types/DeliveryFoodTypes";
import DeliveryFoodCell from "../../DeliveryFoodCell";

export const DeliveryFoodItemRestaurantDeliveryCell = ({
    config,
}: {
    config: DeliveryFoodItemRestaurantCell;
}) => {
    const { deliveryFoodState } = useContext(DeliveryFoodContext);
    const { ingredient, restaurant, restaurantId, index } = config;

    if (deliveryFoodState.mode.display.RST[restaurantId].delivery === false) {
        return null;
    }

    const key = `delivery-cell-${index}`;
    const summary = ingredient.results.RST?.[restaurantId].delivery;

    if (!summary) {
        return null;
    }

    return (
        <DeliveryFoodCell
            key={key}
            fieldName={"delivery"}
            styleName={"DELIVERY"}
            summary={summary}
            index={index}
            ingredient={ingredient}
            restaurant={restaurant}
        />
    );
};
